import React from 'react';
import Icon from '../../../components/AppIcon';

const FleetSummaryCards = () => {
  const summaryData = [
    {
      id: 'ets-exposure',
      title: 'ETS Exposure',
      value: '€2.4M',
      change: '+12.5%',
      changeType: 'increase',
      description: 'Current quarter exposure',
      icon: 'TrendingUp',
      color: 'warning',
      details: {
        hedged: '€1.8M',
        unhedged: '€0.6M',
        coverage: '75%'
      }
    },
    {
      id: 'compliance-status',
      title: 'Fleet Compliance',
      value: '94%',
      change: '+2.1%',
      changeType: 'improvement',
      description: '23 of 24 vessels compliant',
      icon: 'Shield',
      color: 'success',
      details: {
        compliant: 23,
        atRisk: 1,
        total: 24
      }
    },
    {
      id: 'eua-demand',
      title: 'EUA Demand',
      value: '12,450',
      change: '+850',
      changeType: 'increase',
      description: 'Next 3 months forecast',
      icon: 'Calculator',
      color: 'accent',
      details: {
        q4Demand: '12,450',
        purchased: '8,200',
        remaining: '4,250'
      }
    },
    {
      id: 'cost-impact',
      title: 'Cost Impact',
      value: '€185K',
      change: '-€23K',
      changeType: 'improvement',
      description: 'Monthly carbon costs',
      icon: 'DollarSign',
      color: 'primary',
      details: {
        fuel: '€142K',
        ets: '€43K',
        optimization: '-€23K'
      }
    }
  ];

  const getCardStyles = (color) => {
    const styles = {
      success: 'bg-success/10 border-success/20 text-success',
      warning: 'bg-warning/10 border-warning/20 text-warning',
      error: 'bg-error/10 border-error/20 text-error',
      accent: 'bg-accent/10 border-accent/20 text-accent',
      primary: 'bg-primary/10 border-primary/20 text-primary'
    };
    return styles?.[color] || styles?.primary;
  };

  const getChangeIcon = (changeType) => {
    switch (changeType) {
      case 'increase': return 'TrendingUp';
      case 'decrease': return 'TrendingDown';
      case 'improvement': return 'ArrowUp';
      case 'decline': return 'ArrowDown';
      default: return 'Minus';
    }
  };

  const getChangeColor = (changeType) => {
    switch (changeType) {
      case 'improvement': return 'text-success';
      case 'decline': return 'text-error';
      case 'increase': return 'text-warning';
      case 'decrease': return 'text-accent';
      default: return 'text-muted-foreground';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
      {summaryData?.map((card) => (
        <div
          key={card?.id}
          className="maritime-card p-6 hover:shadow-maritime-md transition-maritime"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`p-3 rounded-lg ${getCardStyles(card?.color)}`}>
              <Icon name={card?.icon} size={24} strokeWidth={2} />
            </div>
            <div className={`flex items-center space-x-1 text-sm ${getChangeColor(card?.changeType)}`}>
              <Icon name={getChangeIcon(card?.changeType)} size={16} strokeWidth={2} />
              <span className="font-medium">{card?.change}</span>
            </div>
          </div>

          <div className="space-y-2">
            <h3 className="text-sm font-medium text-muted-foreground">
              {card?.title}
            </h3>
            <div className="text-3xl font-bold text-foreground">
              {card?.value}
            </div>
            <p className="text-sm text-muted-foreground">
              {card?.description}
            </p>
          </div>

          <div className="mt-4 pt-4 border-t border-border">
            <div className="grid grid-cols-3 gap-2 text-xs">
              {Object.entries(card?.details)?.map(([key, value]) => (
                <div key={key} className="text-center">
                  <div className="font-medium text-foreground">{value}</div>
                  <div className="text-muted-foreground capitalize">
                    {key?.replace(/([A-Z])/g, ' $1')?.trim()}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FleetSummaryCards;